import { z } from 'zod';
import { UserKind, UserKindSchema } from '../user/kind.js';
/** Listing an organization's users, narrowed to one kind or, with `all`, not narrowed at all. */
export const OrganizationUsersQuerySchema = z
    .object({
    kind: z.union([UserKindSchema, z.literal('all')]).default(UserKind.Active),
})
    .strict();
//# sourceMappingURL=users.js.map